import React, { useEffect, useState } from 'react'
import { Avatar, Box, Button, Chip, Grid, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ArrowDownward, ArrowUpward, PeopleAltOutlined, Person, ShoppingCartOutlined } from '@mui/icons-material';
import { BsPersonWorkspace } from "react-icons/bs";
import { AiOutlineProduct } from "react-icons/ai";
import AreaChart from '../../Component/Charts/AreaChart';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/store';
import { ApiGetAdminDashboard } from '../../Core/Apicall';
import { toast } from 'react-toastify';
import { ActivityFeed, AdminDashboard, TopClient } from '../../types/AdminDashboard';
import relativeTime from "dayjs/plugin/relativeTime";
import { orderStatusColors } from '../../Component/OrderStatusColors/orderStatusColors';
import { avatarColors } from '../../Component/AvtarColors/AvtarColors';
import SideMenue from '../../Component/SideMenue';

dayjs.extend(relativeTime);


function Dashboard() {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(dayjs());
  const [adminDashobard, setAdminDashboard] = useState<AdminDashboard>()
  const {userDetails } = useSelector((state: RootState) => state.global)


  const headerStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#6B7280",
    borderBottom: "1px solid #F3F4F6",
    whiteSpace: "nowrap",
  };


  const getAvatarColor = (name: string = "") => {
    let total = 0;

    for (let i = 0; i < name.length; i++) {
      total += name.charCodeAt(i);
    }
    const index = total % avatarColors.length;

    return avatarColors[index];
  };
  const getDashboard = async () => {
    try {
      const data = `?month=${(selectedDate?.month() || 0) + 1}&year=${selectedDate?.year()}`
      const res = await ApiGetAdminDashboard(data)
      if (res?.status) {
        setAdminDashboard(res?.data)
      }
    } catch (error: any) {
      toast.error(error?.message || "Somenthing went Worong")
    }
  }

  useEffect(() => {
    selectedDate && getDashboard()
  }, [selectedDate])

  const getActivityIcon = (type: string) => {
    switch (type) {
      case "CLIENT_CREATED":
      case "CLIENT_UPDATED":
      case "CLIENT_DELETED":
      case "SUB_CLIENT_CREATED":
      case "SUB_CLIENT_UPDATED":
      case "SUB_CLIENT_DELETED":
        return <Person className="text-main" />;

      case "PRODUCT_CREATED":
        return AiOutlineProduct({
          size: 24,
          color: "var(--primary-color)",
        });

      case "ORDER_CREATED":
      case "ORDER_STATUS_CHANGED":
      case "ORDER_APPROVED":
      case "ORDER_REJECTED":
      case "ORDER_UPDATED":
      case "PAYMENT_RECEIVED":
      case "INVOICE_CREATED":
        return <ShoppingCartOutlined className="text-main" />;

      default:
        return <Person className="text-main" />;
    }
  };
  return (
    <Box className='p-lg-3 p-xl-4 p-2'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box className="d-flex justify-content-between justify-content-md-end">
          <Box className='d-inline-block d-md-none'>
            <Typography variant='h6' className='fw-bold' sx={{ lineHeight: 'normal' }}>Welcome Back, {userDetails?.firstName}</Typography>
            <Typography sx={{ fontSize: '12px' }}>Here's what's happening with your platform today</Typography>
          </Box>
          <DatePicker
            value={selectedDate}
            onChange={(newValue) => setSelectedDate(newValue)}
            views={['month', 'year']}
            format='MMM-YY'
            slotProps={{
              textField: {
                size: "small",
                sx: { width: { xs: 120, md: 150 } }
              },
            }}
          />
        </Box>
      </LocalizationProvider>
      <Grid container spacing={1} className='my-2'>
        <Grid size={{ xs: 6,md: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>This Month Clients</Typography>
              <Typography variant='h5'>{adminDashobard?.cards?.totalClients?.thisMonth}</Typography>
              {/* <Typography variant='caption'> {(adminDashobard?.cards?.totalClients?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalClients?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalClients?.percentage}%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 bg-second-light border-10'>
                <PeopleAltOutlined className='text-main' sx={{ fontSize: '32px' }} />
              </Box>
            </Grid>
            <Grid size={12}>
              <Typography variant='caption'> {(adminDashobard?.cards?.totalClients?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalClients?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalClients?.percentage}%</span>  from last month</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6,md: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>This Month Dealers</Typography>
              <Typography variant='h5'>{adminDashobard?.cards?.totalDealers?.thisMonth}</Typography>
              {/* <Typography variant='caption'> {(adminDashobard?.cards?.totalDealers?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalDealers?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalDealers?.percentage}%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 bg-second-light border-10'>
                {/* <PeopleAltOutlined className='text-main' sx={{fontSize:'32px'}}/> */}
                {BsPersonWorkspace({ size: 32, color: 'var(--primary-color)' })}
              </Box>
            </Grid>
            <Grid size={12}>
              <Typography variant='caption'> {(adminDashobard?.cards?.totalDealers?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalDealers?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalDealers?.percentage}%</span>  from last month</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6,md: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>this Month Products</Typography>
              <Typography variant='h5'>{adminDashobard?.cards?.totalProducts?.thisMonth}</Typography>
              {/* <Typography variant='caption'> {(adminDashobard?.cards?.totalProducts?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalProducts?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalProducts?.percentage}%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 bg-second-light border-10'>
                {AiOutlineProduct({ size: 32, color: 'var(--primary-color)' })}
              </Box>
            </Grid>
            <Grid size={12}>
              <Typography variant='caption'> {(adminDashobard?.cards?.totalProducts?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalProducts?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalProducts?.percentage}%</span>  from last month</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 6,md: "grow" }} className='border-main card-bg  border-10 p-3'>
          <Grid container>
            <Grid size='grow'>
              <Typography variant='body2'>This Month Orders</Typography>
              <Typography variant='h5'>{adminDashobard?.cards?.totalOrders?.thisMonth}</Typography>
              {/* <Typography variant='caption'> {(adminDashobard?.cards?.totalOrders?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalOrders?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalOrders?.percentage}%</span>  from last month</Typography> */}
            </Grid>
            <Grid size='auto'>
              <Box className='p-2 bg-second-light border-10'>
                <ShoppingCartOutlined className='text-main' sx={{ fontSize: '32px' }} />
              </Box>
            </Grid>
            <Grid size={12}>
              <Typography variant='caption'> {(adminDashobard?.cards?.totalOrders?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalOrders?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalOrders?.percentage}%</span>  from last month</Typography>
              {/* <Typography variant='caption'> {(adminDashobard?.cards?.totalProducts?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalProducts?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalProducts?.percentage}%</span>  from last month</Typography> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, lg: 12, xl: 5 }} className='border-main p-3  card-bg border-10'>
          <Box className='d-flex mb-1 align-items-center justify-content-between'>
            <Typography variant='h6' className='fw-bold'>Revenue Overview</Typography>
          </Box>
          <Typography variant='h4' className='text-main fw-bold'>
            {Number(adminDashobard?.cards?.totalRevenue?.thisMonth)?.toLocaleString("en-US", {
              style: "currency",
              currency: "INR",
            })}</Typography>
          <Typography variant='caption'> {(adminDashobard?.cards?.totalRevenue?.percentage || 0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(adminDashobard?.cards?.totalRevenue?.percentage || 0) >= 0 ? 'text-main' : 'text-danger'}>{adminDashobard?.cards?.totalRevenue?.percentage}%</span>  from last month</Typography>
          <Box className='w-100 mt-2'>
            <AreaChart revenueOverview={adminDashobard?.revenueOverview || []} />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, lg: 6, xl: 4 }} className='border-main p-3  card-bg border-10'>
          <Box className='d-flex mb-1 align-items-center justify-content-between'>
            <Typography variant='h6' className='fw-bold'>Top Clients <span style={{ fontSize: "12px", fontWeight: "normal" }}>(By Revenue)</span></Typography>
          </Box>
          <Box className='mt-4'>
            {adminDashobard?.topClients?.map((client: TopClient, index: number) => (
              <Box className='d-flex align-items-center gap-3 border-bottom-main pb-2 mb-2'>
                <Typography variant='body1'>{index + 1}</Typography>
                <Box className='d-flex align-items-center gap-2' sx={{ flex: 1 }}>
                  <Avatar sx={{ background: 'var(--primary-color)', height: "32px", width: "32px", fontSize: "14px" }}>{client?.companyName?.split(" ")[0][0]}{client?.companyName?.split(" ")[1][0]}</Avatar>
                  <Typography variant='body1'>{client?.companyName}</Typography>
                </Box>
                <Typography variant='body1'>{Number(client?.revenue)?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "INR",
                })}</Typography>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid size={{ xs: 12, lg: 6, xl: 3 }} className='border-main p-3  card-bg border-10'>
          <Box className='d-flex align-items-center justify-content-between'>
            <Typography variant='h6' className='fw-bold'>Activity Feed</Typography>
            <Button variant='outlined' className='btn-outlined-main'> View All</Button>
          </Box>

          <Box className='mt-4'>
            {adminDashobard?.activityFeed?.slice(0, 6)?.map((activity: ActivityFeed, index) => (
              <Box
                key={activity.activityLogId}
                className={`d-flex align-items-center gap-3 pb-2 mb-2 ${index !== adminDashobard.activityFeed.length - 1
                  ? "border-bottom-main"
                  : ""
                  }`}
              >
                <Box
                  className="d-flex align-items-center gap-2"
                  sx={{ flex: 1 }}
                >
                  <Box className="p-1 border-50 bg-second-light">
                    {getActivityIcon(activity.type)}
                  </Box>
                  <Tooltip title={activity.title}>
                    <Typography
                      variant="body2"
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {activity.title}
                    </Typography>
                  </Tooltip>
                </Box>

                <Typography
                  variant="caption"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  {dayjs(activity.created_at).fromNow()}
                </Typography>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1} className='my-2'>
        <Grid size={{ xs: 12, lg: 6 }} className='border-main p-3  card-bg border-10'>
          <Box className='d-flex mb-3 align-items-center justify-content-between'>
            <Typography variant='h6' className='fw-bold'>Recent Clients</Typography>
            <Button className='btn-outlined-main'>View All</Button>
          </Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className='py-1' sx={headerStyle}>CLIENT</TableCell>
                  <TableCell className='py-1' sx={headerStyle}>OWNER</TableCell>
                  <TableCell className='py-1' sx={headerStyle}>CLIENT CODE</TableCell>
                  <TableCell className='py-1 text-center' sx={headerStyle}>STATUS</TableCell>
                  <TableCell className='py-1 text-center' sx={headerStyle}>JOINED</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {adminDashobard?.recentClients?.slice(0, 5).map((row) => {
                  const avatarColor = getAvatarColor(row?.companyName);
                  return (
                    <TableRow
                      key={row.clientId}
                      sx={{
                        "& td": {
                          borderBottom: "1px solid #F3F4F6",
                          py: 2,
                        },
                      }}
                    >
                      <TableCell className='p-0'>
                        <Box className='d-flex align-items-center gap-2'>
                          <Avatar
                            sx={{
                              width: 32,
                              height: 32,
                              bgcolor: avatarColor.bg,
                              color: avatarColor.text,
                              fontSize: 14,
                              fontWeight: 700,
                            }}
                          >
                            {row?.companyName?.split(" ")?.slice(0, 2)?.map((item) => item[0])}
                          </Avatar>

                          <Typography variant='body2'>
                            {row?.companyName}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell className=''>{row?.contactPerson}</TableCell>

                      <TableCell>{row?.clientCode}</TableCell>

                      <TableCell className='text-center'>
                        <Chip
                          label={row.isActive ? "Active" : "Deactive"}
                          size="small"
                          sx={{
                            bgcolor: row.isActive
                              ? "#E8F8EF !important"
                              : "#FDECEC !important",
                            color: row.isActive
                              ? "#24A148 !important"
                              : "#DC2626 !important",
                            fontWeight: 600,
                            borderRadius: "20px",
                          }}
                        />
                      </TableCell>

                      <TableCell className='text-center'>{dayjs(row.createdAt).format("MMM DD, YYYY")}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }} className='border-main p-3  card-bg border-10'>
          <Box className='d-flex mb-3 align-items-center justify-content-between'>
            <Typography variant='h6' className='fw-bold'>Recent Orders</Typography>
            <Button className='btn-outlined-main'>View All</Button>
          </Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="py-1" sx={headerStyle}>
                    ORDER ID
                  </TableCell>
                  <TableCell className="py-1" sx={headerStyle}>
                    CLIENT
                  </TableCell>
                  <TableCell className="py-1" sx={headerStyle}>
                    AMOUNT
                  </TableCell>
                  <TableCell className="py-1 text-center" sx={headerStyle}>
                    STATUS
                  </TableCell>
                  <TableCell className="py-1 text-center" sx={headerStyle}>
                    DATE
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {adminDashobard?.recentOrders?.slice(0, 5).map((row) => {
                  const statusColor =
                    orderStatusColors[row.status] || {
                      bg: "#F3F4F6",
                      color: "#6B7280",
                    };

                  return (
                    <TableRow
                      key={row.orderId}
                      sx={{
                        "& td": {
                          borderBottom: "1px solid #F3F4F6",
                          py: 2,
                        },
                      }}
                    >
                      <TableCell>
                        <Typography variant="body2">
                          {row?.orderNumber}
                        </Typography>
                      </TableCell>

                      <TableCell>{row?.client?.companyName}</TableCell>

                      <TableCell>
                        {Number(row?.totalAmount)?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </TableCell>

                      <TableCell align="center">
                        <Chip
                          label={row.status}
                          size="small"
                          sx={{
                            bgcolor: `${statusColor.bg} !important`,
                            color: `${statusColor.color} !important`,
                            fontWeight: 600,
                            borderRadius: "20px",
                            minWidth: 95,
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" className='text-center'>
                          {dayjs(row?.created_at).format("MMM DD,YYYY")}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Dashboard
